/**
 * Role-based permission constants
 */

import { UserRole } from '../types/user.types';

export const ROLE_PERMISSIONS = {
  // Super Admin has all permissions (inherits from Admin)
  [UserRole.SUPER_ADMIN]: [
    'user.create',
    'user.read',
    'user.update',
    'user.delete',
    'ticket.create',
    'ticket.read',
    'ticket.update',
    'ticket.delete',
    'ticket.assign',
    'leave.approve',
    'leave.reject',
    'attendance.manage',
    'payroll.manage',
    'document.manage',
  ],
  [UserRole.ADMIN]: [
    'user.create',
    'user.read',
    'user.update',
    'user.delete',
    'ticket.create',
    'ticket.read',
    'ticket.update',
    'ticket.delete',
    'ticket.assign',
    'leave.approve',
    'leave.reject',
    'attendance.manage',
    'payroll.manage',
    'document.manage',
  ],
  // [UserRole.HR]: [
  //   'user.create',
  //   'user.read',
  //   'user.update',
  //   'ticket.create',
  //   'ticket.read',
  //   'ticket.update',
  //   'ticket.assign',
  //   'leave.approve',
  //   'leave.reject',
  //   'attendance.view',
  //   'payroll.view',
  //   'document.manage',
  // ],
  // [UserRole.MANAGER]: [
  //   'user.read',
  //   'ticket.create',
  //   'ticket.read',
  //   'ticket.update',
  //   'ticket.assign',
  //   'leave.approve',
  //   'leave.reject',
  //   'attendance.view',
  //   'document.view',
  // ],
  [UserRole.CEO]: [
    'user.create', 'user.read', 'user.update', 'user.delete',
    'ticket.create', 'ticket.read', 'ticket.update', 'ticket.delete', 'ticket.assign',
    'leave.approve', 'leave.reject', 'attendance.manage', 'payroll.manage', 'document.manage',
  ],
  [UserRole.CFO]: [
    'user.create', 'user.read', 'user.update', 'user.delete',
    'ticket.create', 'ticket.read', 'ticket.update', 'ticket.delete', 'ticket.assign',
    'leave.approve', 'leave.reject', 'attendance.manage', 'payroll.manage', 'document.manage',
  ],
  [UserRole.DIRECTOR]: [
    'user.create', 'user.read', 'user.update', 'user.delete',
    'ticket.create', 'ticket.read', 'ticket.update', 'ticket.delete', 'ticket.assign',
    'leave.approve', 'leave.reject', 'attendance.manage', 'payroll.manage', 'document.manage',
  ],
  [UserRole.COO]: [
    'user.create', 'user.read', 'user.update', 'user.delete',
    'ticket.create', 'ticket.read', 'ticket.update', 'ticket.delete', 'ticket.assign',
    'leave.approve', 'leave.reject', 'attendance.manage', 'payroll.manage', 'document.manage',
  ],
  [UserRole.CTO]: [
    'user.create', 'user.read', 'user.update', 'user.delete',
    'ticket.create', 'ticket.read', 'ticket.update', 'ticket.delete', 'ticket.assign',
    'leave.approve', 'leave.reject', 'attendance.manage', 'payroll.manage', 'document.manage',
  ],
  [UserRole.EMPLOYEE]: [
    'ticket.create',
    'ticket.read',
    'leave.create',
    'leave.read',
    'attendance.mark',
    'document.view',
  ],
} as const;

export const hasPermission = (role: UserRole, permission: string): boolean => {
  const permissions = ROLE_PERMISSIONS[role] as readonly string[];
  return permissions ? permissions.includes(permission) : false;
};
